
export const FILE = 'file' as const;
export const FILE_UPLOAD = 'file-upload' as const;
export const MESSAGE = 'message' as const;
export const LINK = 'link' as const;
export const ONLINE = 'online' as const;
export const OFFLINE = 'offline' as const;
export const PREVIEW = 'link-preview' as const;
